module.exports = __webpack_public_path__ + "img/11.928bc678.png";